import axios from 'axios';
import { apiUrl } from '../constant';

// ── Settings ──────────────────────────────────────────────────────────────────

export const getDropshipSettingService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/GetSetting`, data);
};

export const upsertDropshipSettingService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/UpsertSetting`, data);
};

// ── Products ──────────────────────────────────────────────────────────────────

export const listProductForDropshipService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/ListProduct`, data);
};

export const updateDropshipProductService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/UpdateProduct`, data);
};

export const getMyListedProductsService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/GetMyListedProducts`, data);
};

// Lightweight lookup of products this seller has already listed — drives the
// inventory-grid "already listed" icon and pre-fills the edit modal.
export const getMyListedProductIdsService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/GetMyListedProductIds`, data);
};

// Change history for a wholesaler's dropship listings (Dropshipping Settings).
export const getDropshipProductHistoryService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/GetProductHistory`, data);
};

// ── Catalog ───────────────────────────────────────────────────────────────────

export const getDropshipCatalogService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/GetCatalog`, data);
};

export const getDropshipCatalogDetailService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/GetCatalogDetail`, data);
};

// ── Import & Agreements ───────────────────────────────────────────────────────

export const importDropshipProductService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/ImportProduct`, data);
};

export const getDropshipAgreementsService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/GetAgreements`, data);
};

export const updateDropshipAgreementService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/UpdateAgreement`, data);
};

// ── Fulfillment ───────────────────────────────────────────────────────────────

export const getSupplierOrdersService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/GetSupplierOrders`, data);
};

export const updateFulfillmentService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/UpdateFulfillment`, data);
};

// ── 3PL Margin Config ─────────────────────────────────────────────────────────

export const getDropshipMarginConfigService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/GetMarginConfig`, data);
};

export const upsertDropshipMarginConfigService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/UpsertMarginConfig`, data);
};

export const deleteDropshipMarginConfigService = (data) => {
    return axios.post(`${apiUrl}/api/Dropship/DeleteMarginConfig`, data);
};
